module.exports = __webpack_public_path__ + "static/media/modern-editor-1A.d9f41cca.png";